import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import { AffiliateSessionProvider } from './contexts/AffiliateSessionContext';
import { DemoModeProvider } from './contexts/DemoModeContext';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <DemoModeProvider>
        <AdminAuthProvider>
          <AffiliateSessionProvider>
            <App />
          </AffiliateSessionProvider>
        </AdminAuthProvider>
      </DemoModeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
